<template>
  <pano-container>
    <div class="page-title" :class="screen" v-if="hallTitle">{{ hallTitle }}</div>
    <div class="page-footer" :class="screen" v-show="data.id">
      <template v-if="packages.length">
        <div class="action-item" @click="togglePackage(true)">
          <img class="icon" src="./images/package_icon.png" />
          <span>套餐服务</span>
        </div>
        <div class="sep"></div>
      </template>
      <div class="action-item" @click="toggleSwitch(true)">
        <img class="icon" src="./images/switch_icon.png" />
        <span>切换场地</span>
      </div>
      <div class="sep"></div>
      <div class="action-item" @click="state.hallVisible = true">
        <img class="icon" src="../goods/images/detail_icon.png" />
        <span>场地详情</span>
      </div>
      <div class="sep"></div>
      <div class="action-item" @click="openKf">
        <img class="icon" src="./images/service_icon2.png" />
        <span>咨询管家</span>
      </div>
    </div>
  </pano-container>

  <!-- <hotel-dialog
    :data="data"
    :picture="picture"
    :tags="tags"
    :visible="state.visible"
    @cancel="state.visible = false"
    @collect="collect"
  /> -->
  <switch-dialog
    :visible="state.switchVisible"
    :screen="screen"
    :list="list"
    @cancel="toggleSwitch(false)"
    @select="select"
  />
  <package-dialog :list="packages" :visible="state.packageVisible" @cancel="togglePackage(false)" />
  <hall-dialog
    :cate="hallCate"
    :screen="screen"
    :data="hallDetail"
    :visible="state.hallVisible"
    @cancel="state.hallVisible = false"
  />

  <img v-if="targetHall.is_has_ex" src="./images/ai_btn.png" class="travel-animate-fade-down ai-btn" @click="toGoods" />
</template>

<script>
import qs from '@halobear/utils/qs'
import { onBeforeMount, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { open } from '@/utils/53kf'
import du from '@/utils/statistics'
import callPhone from '@/utils/callPhone'
import useTravel from '@/composables/use-travel'
import usePackage from '@/composables/use-package'

import PanoContainer from '@/components/pano-container'
// import HotelDialog from './components/hotel-dialog';
import SwitchDialog from './components/switch-dialog'
import PackageDialog from './components/package-dialog'
import HallDialog from './components/hall-dialog'

export default {
  components: {
    PanoContainer,
    // HotelDialog,
    SwitchDialog,
    PackageDialog,
    HallDialog,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const state = reactive({
      panoKey: '',
      visible: false,
      packageVisible: false,
      switchVisible: false,
      hallVisible: false,
    })
    const { packages } = usePackage()
    const {
      data = {},
      tags = [],
      hallDetail = {},
      picture = [],
      hallTitle,
      list,
      collect,
      isCollect,
      hallCate,
      targetHall,
      fetchHallDetail,
      share,
    } = useTravel()
    const togglePackage = (visible = !state.packageVisible) => {
      state.packageVisible = visible
    }
    const toggleSwitch = (visible = !state.switchVisible) => {
      state.switchVisible = visible
    }

    // 横屏样式，暂时未用到
    const { screen = 'vertical' } = route.query

    const select = (item) => {
      state.switchVisible = false
      let { hotel_id, hall_id, hotel_name } = item
      router.replace({
        query: {
          ...route.query,
          id: item.id || '',
          hall_id: item.hall_id,
          hotel_id: item.hotel_id,
        },
      })
      // 防止获取不到正确url
      setTimeout(() => {
        fetchHallDetail()
        state.panoKey = `pano_${item.hotel_id}_${item.hall_id}`
        share()
      }, 300)
      du.trackEvent('halldetail_hall_click', '场地详情-点击切换场地', `${hotel_id}-${hall_id}-${hotel_name}`)
    }
    const openKf = () => {
      const { hall_id = '', hotel_id = '', phone = '' } = route.query.hall_id
        ? route.query
        : qs.parse(window.location.search.split('?')[1] || '')
      if (phone) {
        window.location.href = `tel:${phone}`
      } else {
        open()
      }
      du.trackEvent('halldetail_service_click', '场地详情-点击咨询管家', `${hotel_id}-${hall_id}-${data.value.name}`)
    }

    const toGoods = () => {
      const { hall_id, hotel_id, first_pano_id = '' } = targetHall.value
      const { title = '', phone } = route.query.hall_id
        ? route.query
        : qs.parse(window.location.search.split('?')[1] || '')
      if (!hall_id) return
      const query = { hall_id, hotel_id, pano_id: first_pano_id, title }
      phone && (query.phone = phone)
      router.replace({
        name: 'goods',
        query,
      })
    }

    onBeforeMount(() => {
      const { hall_id = '', hotel_id = '' } = route.query.hall_id
        ? route.query
        : qs.parse(window.location.search.split('?')[1] || '')
      state.panoKey = `pano_${hotel_id}_${hall_id}`
    })

    return {
      list,
      callPhone,
      state,
      data,
      hallDetail,
      tags,
      picture,
      togglePackage,
      toggleSwitch,
      openKf,
      select,
      collect,
      isCollect,
      hallTitle,
      hallCate,
      targetHall,
      packages,
      screen,
      toGoods,
    }
  },
}
</script>

<style lang="less" scoped>
.page-title {
  width: 750px;
  height: 92px;
  line-height: 92px;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.36) 51%, rgba(0, 0, 0, 0) 100%);
  text-align: center;
  color: white;
  font-size: 32px;
  font-weight: bold;
  position: fixed;
  top: 20px;
  left: 0;
  right: 0;
  margin: auto;
  &.landscape {
    font-size: 18px;
    height: 40px;
    line-height: 40px;
  }
}
.page-footer {
  width: 750px;
  height: 152px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.8) 100%);
  border-radius: 12px 12px 0px 0px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  font-size: 28px;
  color: white;
  user-select: none;
  &.landscape {
    transform: scale(0.5) translateY(50%);
  }
  .action-item {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    &:active {
      opacity: 0.88;
    }
  }
  .icon {
    width: 40px;
    height: 40px;
    margin-bottom: 14px;
  }
  .sep {
    flex-shrink: 0;
    width: 4px;
    height: 72px;
    box-shadow: 1px 0px 0px 0px rgba(255, 255, 255, 1);
    background-color: #fff;
    opacity: 0.3;
    transform: scaleX(0.5);
    margin: 0 20px;
  }
  .contact-btn {
    width: 180px;
    height: 72px;
    background: #e03e5d;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    margin-left: 60px;
  }
}
.ai-btn {
  width: 120px;
  height: 140px;
  position: absolute;
  bottom: 192px;
  right: 20px;
  z-index: 100;
  cursor: pointer;
}
@keyframes slideFadeDown {
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.travel-animate-fade-down {
  animation: slideFadeDown ease 1s both;
}
</style>
